module.exports = __webpack_public_path__ + "img/LTE:ERR - WLAN:OK.a6766a6e.jpg";